import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import Button from '../common/Button';
import { map } from 'lodash';
import AddUserPopUp from './AddUserPopUp.jsx';
import Gmaps from '../common/Gmaps';
import { imageBasePath, appBasePath } from '../../constants/staticData';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class MyVehicles extends Component {
  constructor(props) {
    super(props);
    this.addVehicle = this.addVehicle.bind(this);
    this.viewLocation = this.viewLocation.bind(this);
    this.state = {
      searchMobile: false,
      showSidebar: false
    };
  }

  componentWillMount() {
    this.props.actions.manageVehicleinfo();
  }

  componentWillUnmount() {
    //this.props.actions.hideErrorMessage();
  }

  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }

  toggleMessage(isVisible) {
    this.setState({ messageVisible: isVisible });
  }

  addVehicle() {
    this.props.router.push(`${appBasePath}/add-Vehicle`);
  }

  viewLocation(lat, long) {
    let InfoLongLat = { latitude: lat, longititude: long };
    this.props.actions.MapsInfo(InfoLongLat);
    this.props.actions.showPopUP();
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }
  render() {
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    const { authReducer, manageuserReducer } = this.props;
    return (
      <div>
        <AddUserPopUp showpopupType="Maps" manageVehicle={this.props.manageuserReducer} actions={this.props.actions}>
          {' '}
        </AddUserPopUp>
        {/*Header*/}
        <Header
          searchMobile={this.state.searchMobile}
          hideOption={() => this.setState({ searchMobile: true })}
          commonReducer={this.props.commonReducer}
          actions={this.props.actions}
          notificationCount={2}
          profileName="Derrick Frank"
          noAutoSuggestCall="true"
          notificationCallBack={this.toggleNotification}
          authReducer={this.props.authReducer}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={this.props.router}
          isNewUser={
            authData &&
              authData.isBusinessRegistered &&
              authData.isGarageProfileCompleted &&
              authData.isGarageServiceSelected
              ? false
              : true
          }
        />
        <div className="main-wrapper">

          <Sidebar
            showSidebar={this.state.showSidebar}
            router={this.props.router}
            actions={this.props.actions}
            commonReducer={this.props.commonReducer}
            authReducer={this.props.authReducer}
          />
          {/*message*/}
          {/*<Extra message="Your email account has been verified. We are open for service!" />*/}

          <div className="container-fluid main-container">
            <div className="page-sec-header col">
              <div className="overview-heading headrer-left-pod my-vehicles-box overview-heading-mob row">
                <h5>My Vehicles</h5>
                {manageuserReducer.vehicleInfo.length > 0 &&
                  <Button
                    btnType="label"
                    btnSize="sm"
                    fontSize={13}
                    label="Add Vehicle"
                    btnCallBack={() => this.addVehicle(this)}
                    customClass="btn-add-user"
                  />}
              </div>
              <div className="my-account-body">

                {manageuserReducer.vehicleInfo.length > 0 &&
                  manageuserReducer.displayloader == false &&
                  map(manageuserReducer.vehicleInfo, (info, index) => {
                    let phoneNumber = 'tel:' + info.phone;
                    return (
                      <div className="container-fluid vehicle-list-row" key={info.name}>
                        <div className="row clearfix">
                          <div className="col-sm-2 col-xs-12 vehicle-map-list container-fluid">
                            <div className="vehicle-map">
                              <div className="gmaps-opac">
                              </div>
                              <Gmaps
                                mapDrag={()=>{
                                }}
                                markerDrag={()=>{}}
                                on
                                center={{
                                  lat: Number(info.latitude),
                                  lng: Number(info.longitude)
                                }}
                                marker={{
                                  position: {
                                    lat: Number(info.latitude),
                                    lng: Number(info.longitude)
                                  }
                                }}
                                zoom={15}
                                containerElement={<div style={{ height: 'auto', width: 100 + '%' }} />}
                                mapElement={<div style={{ height: 120 + 'px', width: 100 + '%' }} />}
                              />
                            </div>
                            <div className="vehicle-name">{info.name}</div>
                          </div>
                          <div className="col-sm-3 col-xs-12 vehicle-driver-info">
                            <div className="vehicle-element-info">{info.plateNo}</div>
                            <div className="vehicle-element-info vehicle-name">{info.username}</div>
                            <div className="vehicle-element-info vehicle-link-color user-phone">
                              <label className="mdi mdi-phone" />
                              <a href={phoneNumber}>{info.phone}</a>
                            </div>
                            <div
                              className="vehicle-element-info vehicle-link-color view-location user-phone vehicle-location-txt"
                              onClick={() => this.viewLocation(info.latitude, info.longitude)}
                            >
                              View Location
                            </div>
                          </div>
                          <div className="col-sm-5  col-xs-12 vehicle-driver-info">
                            <div className="vehicle-element-info visible-none hide-dummy">dummy</div>
                            <div className="vehicle-element-info">{info.name}</div>
                            <div className="vehicle-element-info">
                              Current Status: {info.emergencyvehiclestatus.displayname}
                            </div>
                            <div className="vehicle-element-info">Job Queue: {info.jobqueue}</div>
                          </div>
                          <div className="col-sm-2 col-xs-10 container-fluid manage-button hide-manage-btn">
                            <Button
                              btnType="label"
                              btnSize="sm"
                              fontSize={13}
                              label="Manage"
                              btnCallBack={() =>
                                this.props.router.push(`${appBasePath}/vehicle-personal-info/${info.id}`)}
                              customClass="vehicle-button manage-button"
                            />
                          </div>
                          <div className="manage-btn-box col-xs-12">
                            <Button
                              btnType="label"
                              btnSize="sm"
                              fontSize={13}
                              label="Manage"
                              btnCallBack={() =>
                                this.props.router.push(`${appBasePath}/vehicle-personal-info/${info.id}`)}
                              customClass="vehicle-button manage-button manage-btn-wrapper"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {manageuserReducer.vehicleInfo.length == 0 &&
                  manageuserReducer.displayloader == false &&
                  <div className="empty-list-display">
                    <img src={`${imageBasePath}/emergency_vehicle_empty.png`} alt="No User Details" />
                    <h5>Oops! Looks like you haven't added any Emergency Vehicles yet.</h5>
                    <Button
                      btnType="label"
                      btnSize="sm"
                      fontSize={16}
                      label="Add Vehicle"
                      btnCallBack={() => this.addVehicle(this)}
                      customClass="btn-add-user add-veh-empty"
                    />
                  </div>}
                {manageuserReducer.displayloader == true &&
                  <div className="page-loader">
                    <div className="loader-image">
                      <img src={`${imageBasePath}/loader.gif`} />
                    </div>
                  </div>}
              </div>

            </div>
          </div>
        </div>
        {this.state.searchMobile &&
          <div>

            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MyVehicles/myVehicles.jsx